import httpService from '../_utils/http-service';

import { getHttpConfig } from '../_utils/auth-utils';

import { traceEvent, reportError } from "../_utils/analytics-utils";

export const forgotPassword = (email, callback) => {

    return function (dispatch) {

        const { protocol, host } = window.location;

        const callbackUrl = `${protocol}//${host}/reset-password/`;

        httpService.post(
            '/customers/forgot',
            { email, callbackUrl },
            getHttpConfig()
        )
            .then((res) => {

                if (res.data.statusCode === 200) {
                    callback({ success: true });
                } else {
                    reportError("forgotPassword", {res});
                    callback({ success: false });
                }

            }).catch(err => {
             
                reportError("forgotPassword", {err});
                callback({ success: false });
            })
    }
}

export const resetPassword = (payload, resetToken, callback) => {

    return function (dispatch) {
        httpService.put(
            `/customers/reset/${resetToken}`,
            payload,
            getHttpConfig(),
        )
            .then((res) => {
                if (res.data.statusCode === 200) {
                    callback({ success: true });
                } else {
                    traceEvent("error", "resetPassword");
                    callback({ success: false });
                }
            }).catch(err => {
                traceEvent("error", "resetPassword");
                callback({ success: false });
            })
    }
}
